import React from 'react';

import { Hand } from '../../components/Hand/Hand';
import { HandV1 } from '../../components/HandV1/HandV1';
import { featureStateHooks } from '../../hooks/featureStateHooks/featureStateHooks';
import { layoutHooks } from '../../hooks/layoutHooks/layoutHooks';

export const HandContainer = () => {
  const layoutExtension = layoutHooks.useLayoutExtension();
  const { isHandV1 } = featureStateHooks.useFeatureToggles();
  return (isHandV1
    ? <HandV1 layoutExtension={layoutExtension} />
    : <Hand layoutExtension={layoutExtension} isCropped={true} />);
};

HandContainer.displayName = 'HandContainer';
